import { render } from "./customer-details-agingreport.vue?vue&type=template&id=4be94ca6"
import script from "./customer-details-agingreport.vue?vue&type=script&lang=js"
export * from "./customer-details-agingreport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__